import { AppDialog, AppInput } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useGCompanyDialog } from './hooks/useGCompanyDialog'

/**
 * GCompanyDialog コンポーネントの Props
 *
 * @param open - ダイアログの表示状態
 * @param onOpenChange - ダイアログの表示状態変更ハンドラ
 * @param opportunity - 対象オポチュニティ（nullの場合は非表示）
 * @param onSubmit - G会社商流情報送信ハンドラ
 */
interface GCompanyDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  opportunity: {
    id: number
    title: string
    g_company_name?: string | null
    g_company_contact?: string | null
  } | null
  onSubmit: (data: { gCompanyName: string; gCompanyContact: string }) => void
}

/**
 * オポチュニティG会社商流ダイアログ
 *
 * G会社商流のオポチュニティに対してG会社名とG社担当者を入力するダイアログです。
 */
export function GCompanyDialog({ open, onOpenChange, opportunity, onSubmit }: GCompanyDialogProps) {
  const {
    gCompanyName,
    gCompanyContact,
    gCompanyNameError,
    gCompanyContactError,
    hasErrors,
    handleNameChange,
    handleContactChange,
    handleSubmit,
  } = useGCompanyDialog({
    open,
    opportunity,
    onSubmit,
    onOpenChange,
  })

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title='G会社商流情報'
      className='max-w-137.5'
      footerOptions={[
        { label: 'キャンセル', onClick: () => onOpenChange(false), variant: 'outline' },
        { label: '保存', variant: 'save' as const, onClick: handleSubmit, disabled: hasErrors },
      ]}
    >
      <div className='space-y-4'>
        <AppInput
          id='g-company-name'
          label='G会社名'
          required
          value={gCompanyName}
          onChange={(e) => handleNameChange(e.target.value)}
          placeholder='例：G会社株式会社'
          error={gCompanyNameError ?? undefined}
        />

        <AppInput
          id='g-company-contact'
          label='G社担当者'
          required
          value={gCompanyContact}
          onChange={(e) => handleContactChange(e.target.value)}
          placeholder='例：山田 太郎'
          error={gCompanyContactError ?? undefined}
        />
      </div>
    </AppDialog>
  )
}
